import { Injectable } from "@angular/core";
import { CoreHttpClient } from "@obg/ngx.core";
import { Observable } from "rxjs";

import { RegistrationConfigService } from "../registration.config";

import { BANK_ID_RETURN_PATH, BANK_ID_RETURN_URL_PARAMETER_NAME } from "./registration-with-bank-id.const";
import { GetBankIdRegistrationUrlSuccessPayload } from "./registration-with-bank-id.model";

@Injectable({
	providedIn: "root",
})
export class RegistrationWithBankIdService {
	constructor(
		private httpClient: CoreHttpClient,
		private registrationConfig: RegistrationConfigService
	) {}

	getBankIdRegistrationUrl(): Observable<GetBankIdRegistrationUrlSuccessPayload> {
		const url = this.registrationConfig.getBankIdRegistrationUrl();
		return this.httpClient.get<GetBankIdRegistrationUrlSuccessPayload>({
			url,
		});
	}

	addReturnUrl(url: string): string {
		const returnUrl = `${window.location.protocol}//${window.location.host}/${BANK_ID_RETURN_PATH}`;

		return `${url}?${BANK_ID_RETURN_URL_PARAMETER_NAME}=${returnUrl}`;
	}
}
